"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1469))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.515Z
 */
export const CustomerSupport = createSVGIcon(
  <>
    <path
      d="M5.14258 11.9994V7.49084C5.15597 6.60461 5.3441 5.72973 5.69619 4.91633C6.04828 4.10293 6.55741 3.367 7.1944 2.7507C7.8314 2.13441 8.58375 1.64986 9.40833 1.32483C10.2329 0.999794 11.1135 0.840663 11.9997 0.856551V0.856551C12.8859 0.840663 13.7665 0.999794 14.5911 1.32483C15.4157 1.64986 16.168 2.13441 16.805 2.7507C17.442 3.367 17.9512 4.10293 18.3033 4.91633C18.6553 5.72973 18.8435 6.60461 18.8569 7.49084V11.9994"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.57122 9.42798H4.2855C4.51283 9.42798 4.73085 9.51828 4.8916 9.67903C5.05234 9.83978 5.14265 10.0578 5.14265 10.2851V15.428C5.14265 15.6553 5.05234 15.8733 4.8916 16.0341C4.73085 16.1948 4.51283 16.2851 4.2855 16.2851H2.57122C2.11656 16.2851 1.68053 16.1045 1.35904 15.783C1.03755 15.4615 0.856934 15.0255 0.856934 14.5708V11.1423C0.856934 10.6876 1.03755 10.2516 1.35904 9.93008C1.68053 9.60859 2.11656 9.42798 2.57122 9.42798V9.42798Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.4283 16.2851H19.714C19.4867 16.2851 19.2687 16.1948 19.1079 16.034C18.9472 15.8733 18.8569 15.6553 18.8569 15.428V10.2851C18.8569 10.0578 18.9472 9.83975 19.1079 9.679C19.2687 9.51826 19.4867 9.42795 19.714 9.42795H21.4283C21.8829 9.42795 22.319 9.60856 22.6405 9.93006C22.962 10.2515 23.1426 10.6876 23.1426 11.1422V14.5708C23.1426 15.0255 22.962 15.4615 22.6405 15.783C22.319 16.1045 21.8829 16.2851 21.4283 16.2851V16.2851Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4285 20.9994C16.3378 20.9994 17.2099 20.6382 17.8528 19.9952C18.4958 19.3522 18.857 18.4801 18.857 17.5708V13.7137"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4284 20.9994C15.4284 21.5677 15.2027 22.1128 14.8008 22.5147C14.3989 22.9165 13.8539 23.1423 13.2856 23.1423H10.7141C10.1458 23.1423 9.60078 22.9165 9.19892 22.5147C8.79705 22.1128 8.57129 21.5677 8.57129 20.9994C8.57129 20.4311 8.79705 19.8861 9.19892 19.4842C9.60078 19.0823 10.1458 18.8566 10.7141 18.8566H13.2856C13.8539 18.8566 14.3989 19.0823 14.8008 19.4842C15.2027 19.8861 15.4284 20.4311 15.4284 20.9994Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CustomerSupport",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
